import axios from './axios';
import {ResearcherFormValue} from "../components/ResearcherForm";

export default async function getStudyResearchers(studyName: string): Promise<ResearcherFormValue> {
  const response = await axios.get(`/study/${studyName}/researchers`);
  return {researchers: response.data.researchers};
}
